import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";

@Component({
  selector: "selfservice-toggle",
  templateUrl: "selfservice-toggle.html",
  styleUrl: "selfservice-toggle.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatTooltip],
})
export class SelfserviceToggle {
  protected active = input.required<boolean>();
  protected tooltipText = input("");
  protected disabled = input<boolean>(false);

  protected propagateClick = computed(() => !this.disabled());
}
